import { X, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface BulkActionBarProps {
  count: number;
  onClear: () => void;
  children: React.ReactNode;
  entityLabel?: string;
}

export function BulkActionBar({ count, onClear, children, entityLabel = "item" }: BulkActionBarProps) {
  if (count === 0) return null;

  return (
    <div className="flex items-center justify-between rounded-t-lg border border-b-0 bg-primary px-4 py-2.5 text-primary-foreground">
      <span className="text-sm font-medium">
        {count} {entityLabel}{count !== 1 ? "s" : ""} selected
      </span>
      <div className="flex items-center gap-2">
        {children}
        <div className="h-4 w-px bg-primary-foreground/30" />
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 text-primary-foreground hover:bg-primary-foreground/20 hover:text-primary-foreground"
          onClick={onClear}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
